import React from "react";
import { Link } from "react-router-dom";
import logo from "../imgs/logo.png";

const Support = () => {
  return (
    <div className="legal-page">
      {/* Navigation Header */}
      <div className="legal-nav">
        <div className="legal-nav-container">
          <Link to="/" className="back-button">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
            </svg>
            Back
          </Link>

          <div className="legal-nav-brand">
            <img src={logo} alt="Viralz Logo" className="legal-nav-logo" />
            <span className="legal-nav-title">Viralz</span>
          </div>
        </div>
      </div>

      <div className="legal-container">
        <h1>Support</h1>
        <div className="legal-meta">
          <p>
            <strong>Effective Date:</strong> January 1, 2025
          </p>
          <p>
            <strong>Last Updated:</strong> January 1, 2025
          </p>
        </div>

        <section>
          <h2>1. GETTING HELP</h2>
          <p>
            We're here to help you get the most out of Viralz. This section
            provides information about available support options and resources.
          </p>
        </section>

        <section>
          <h2>2. CONTACT METHODS</h2>

          <h3>2.1 Email Support</h3>
          <ul>
            <li>
              <strong>General Support:</strong> viralzmanagement@gmail.com
            </li>
            <li>
              <strong>Technical Issues:</strong> viralzmanagement@gmail.com
            </li>
            <li>
              <strong>Billing Questions:</strong> viralzmanagement@gmail.com
            </li>
            <li>
              <strong>Privacy Concerns:</strong> viralzmanagement@gmail.com
            </li>
            <li>
              <strong>Business Inquiries:</strong> viralzmanagement@gmail.com
            </li>
          </ul>

          <h3>2.2 Response Times</h3>
          <ul>
            <li>
              <strong>General Inquiries:</strong> 24-48 hours
            </li>
            <li>
              <strong>Technical Issues:</strong> 12-24 hours
            </li>
            <li>
              <strong>Billing Questions:</strong> 12-24 hours
            </li>
            <li>
              <strong>Premium Users:</strong> Priority support (6-12 hours)
            </li>
          </ul>
        </section>

        <section>
          <h2>3. COMMON ISSUES AND SOLUTIONS</h2>

          <h3>3.1 Account Issues</h3>
          <div className="issue-block">
            <h4>Problem: Can't log in to my account</h4>
            <p>
              <strong>Solution:</strong>
            </p>
            <ol>
              <li>Ensure you're using the correct email address</li>
              <li>Try signing in with Apple/Google again</li>
              <li>Check your internet connection</li>
              <li>Update the app to the latest version</li>
              <li>Contact support if the issue persists</li>
            </ol>
          </div>

          <div className="issue-block">
            <h4>Problem: Account data is missing</h4>
            <p>
              <strong>Solution:</strong>
            </p>
            <ol>
              <li>Pull down to refresh the app</li>
              <li>Check your internet connection</li>
              <li>Verify your TikTok username is correct</li>
              <li>Log out and log back in</li>
              <li>Contact support for data recovery</li>
            </ol>
          </div>

          <h3>3.2 TikTok Analysis Issues</h3>
          <div className="issue-block">
            <h4>Problem: TikTok data not loading</h4>
            <p>
              <strong>Solution:</strong>
            </p>
            <ol>
              <li>Ensure your TikTok profile is public</li>
              <li>Check that your TikTok username is correct</li>
              <li>Wait a few minutes and try again</li>
              <li>Refresh the analysis manually</li>
              <li>Contact support if data remains unavailable</li>
            </ol>
          </div>

          <div className="issue-block">
            <h4>Problem: Analysis results seem incorrect</h4>
            <p>
              <strong>Solution:</strong>
            </p>
            <ol>
              <li>Verify your TikTok username is spelled correctly</li>
              <li>Ensure your TikTok profile is public</li>
              <li>Check that you have recent videos posted</li>
              <li>Wait for the next data refresh cycle</li>
              <li>Report specific discrepancies to our support team</li>
            </ol>
          </div>

          <h3>3.3 Subscription Issues</h3>
          <div className="issue-block">
            <h4>Problem: Subscription not working</h4>
            <p>
              <strong>Solution:</strong>
            </p>
            <ol>
              <li>Check your subscription status in App Store/Google Play</li>
              <li>Restart the app completely</li>
              <li>Verify your payment method is valid</li>
              <li>Restore purchases in the app</li>
              <li>Contact support with your purchase receipt</li>
            </ol>
          </div>

          <div className="issue-block">
            <h4>Problem: Can't cancel subscription</h4>
            <p>
              <strong>Solution:</strong>
            </p>
            <ol>
              <li>Go to your device's subscription settings</li>
              <li>Find Viralz in your active subscriptions</li>
              <li>Select "Cancel Subscription"</li>
              <li>Confirm the cancellation</li>
              <li>Contact support if you need assistance</li>
            </ol>
          </div>

          <h3>3.4 App Performance Issues</h3>
          <div className="issue-block">
            <h4>Problem: App is slow or crashing</h4>
            <p>
              <strong>Solution:</strong>
            </p>
            <ol>
              <li>Close and restart the app</li>
              <li>Restart your device</li>
              <li>Update to the latest app version</li>
              <li>Clear the app cache (Android)</li>
              <li>Reinstall the app if necessary</li>
            </ol>
          </div>

          <div className="issue-block">
            <h4>Problem: Features not working properly</h4>
            <p>
              <strong>Solution:</strong>
            </p>
            <ol>
              <li>Check your internet connection</li>
              <li>Update the app to the latest version</li>
              <li>Try the feature again after a few minutes</li>
              <li>Restart the app</li>
              <li>Report the issue to our support team</li>
            </ol>
          </div>
        </section>

        <section>
          <h2>4. FEATURE REQUESTS</h2>
          <p>We welcome your suggestions for new features and improvements:</p>
          <ul>
            <li>
              <strong>Email:</strong> viralzmanagement@gmail.com
            </li>
            <li>
              <strong>Subject Line:</strong> "Feature Request: [Brief
              Description]"
            </li>
            <li>
              <strong>Include:</strong> Detailed description of the requested
              feature
            </li>
            <li>
              <strong>Priority:</strong> How important this feature is to you
            </li>
            <li>
              <strong>Use Case:</strong> How you would use this feature
            </li>
          </ul>
        </section>

        <section>
          <h2>5. BUG REPORTS</h2>
          <p>Help us improve Viralz by reporting bugs:</p>
          <ul>
            <li>
              <strong>Email:</strong> viralzmanagement@gmail.com
            </li>
            <li>
              <strong>Include:</strong>
              <ul>
                <li>Device model and operating system version</li>
                <li>App version number</li>
                <li>Step-by-step description of the issue</li>
                <li>Screenshots or screen recordings (if applicable)</li>
                <li>What you expected to happen vs. what actually happened</li>
              </ul>
            </li>
          </ul>
        </section>

        <section>
          <h2>6. PREMIUM SUPPORT</h2>
          <p>Premium subscribers receive priority support with:</p>
          <ul>
            <li>
              <strong>Faster Response Times:</strong> 6-12 hours for most
              inquiries
            </li>
            <li>
              <strong>Direct Access:</strong> Dedicated support channel
            </li>
            <li>
              <strong>Advanced Troubleshooting:</strong> In-depth technical
              assistance
            </li>
            <li>
              <strong>Feature Guidance:</strong> Help maximizing premium
              features
            </li>
          </ul>
        </section>

        <section>
          <h2>7. EMERGENCY CONTACT</h2>
          <p>For urgent security issues or data breaches:</p>
          <ul>
            <li>
              <strong>Email:</strong> viralzmanagement@gmail.com
            </li>
            <li>
              <strong>Subject Line:</strong> "URGENT: Security Issue"
            </li>
            <li>
              <strong>Response Time:</strong> Within 4 hours
            </li>
          </ul>
        </section>

        <section>
          <h2>8. CONTACT US</h2>
          <p>For general support inquiries:</p>
          <ul>
            <li>
              <strong>Email:</strong> viralzmanagement@gmail.com
            </li>
            <li>
              <strong>Website:</strong> https://viralzapp.com/support
            </li>
            <li>
              <strong>Response Time:</strong> Within 24-48 hours
            </li>
          </ul>
        </section>
      </div>

      <style jsx>{`
        .legal-page {
          min-height: 100vh;
          background: #000000;
          color: #ffffff;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
            sans-serif;
          padding: 0;
        }

        .legal-nav {
          background: rgba(0, 0, 0, 0.95);
          backdrop-filter: blur(20px);
          border-bottom: 1px solid rgba(254, 44, 85, 0.2);
          padding: 20px 0;
          position: sticky;
          top: 0;
          z-index: 100;
        }

        .legal-nav-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .back-button {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #ffffff;
          text-decoration: none;
          font-weight: 600;
          font-size: 1rem;
          padding: 10px 16px;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: all 0.3s ease;
        }

        .back-button:hover {
          background: rgba(254, 44, 85, 0.2);
          border-color: #fe2c55;
          color: #fe2c55;
          transform: translateX(-2px);
        }

        .legal-nav-brand {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .legal-nav-logo {
          width: 32px;
          height: 32px;
          border-radius: 8px;
          background: rgba(254, 44, 85, 0.1);
          padding: 4px;
          border: 1px solid rgba(254, 44, 85, 0.3);
        }

        .legal-nav-title {
          font-size: 1.5rem;
          font-weight: 800;
          color: #fe2c55;
        }

        .legal-container {
          max-width: 800px;
          margin: 0 auto;
          line-height: 1.6;
          padding: 40px 20px;
        }

        h1 {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 20px;
          background: linear-gradient(135deg, #fe2c55, #ff6b9d);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .legal-meta {
          margin-bottom: 40px;
          padding: 20px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
          border: 1px solid rgba(254, 44, 85, 0.2);
        }

        .legal-meta p {
          margin: 5px 0;
          color: #cccccc;
        }

        section {
          margin-bottom: 40px;
        }

        h2 {
          font-size: 1.8rem;
          font-weight: 700;
          margin-bottom: 20px;
          color: #fe2c55;
        }

        h3 {
          font-size: 1.4rem;
          font-weight: 600;
          margin-bottom: 15px;
          color: #ffffff;
        }

        h4 {
          font-size: 1.2rem;
          font-weight: 600;
          margin-bottom: 10px;
          color: #ff6b9d;
        }

        p {
          margin-bottom: 15px;
          color: #cccccc;
        }

        ul {
          margin-bottom: 20px;
          padding-left: 20px;
        }

        ol {
          margin-bottom: 20px;
          padding-left: 20px;
        }

        li {
          margin-bottom: 10px;
          color: #cccccc;
        }

        strong {
          color: #ffffff;
        }

        .issue-block {
          margin-bottom: 30px;
          padding: 20px;
          background: rgba(255, 255, 255, 0.03);
          border-radius: 10px;
          border: 1px solid rgba(254, 44, 85, 0.1);
        }

        .issue-block h4 {
          margin-top: 0;
        }

        .issue-block ol {
          margin-top: 10px;
        }

        @media (max-width: 768px) {
          .legal-container {
            padding: 20px 15px;
          }

          .legal-nav-container {
            padding: 0 15px;
          }

          .legal-nav-title {
            font-size: 1.3rem;
          }

          .legal-nav-logo {
            width: 28px;
            height: 28px;
          }

          .back-button {
            padding: 8px 12px;
            font-size: 0.9rem;
          }

          h1 {
            font-size: 2rem;
          }

          h2 {
            font-size: 1.5rem;
          }

          h3 {
            font-size: 1.2rem;
          }

          h4 {
            font-size: 1.1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Support;
